import React from 'react'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { Person } from '../../App/store/features/person/IPerson'
import { setUserSettings } from '../settings/userSettings'
import {
  calendarSettingsSelector,
  setInActivePersonIds,
} from '../store/calendarSlice'

import {
  UserSettingsAvatar,
  UserSettingsText,
  UsersSettingsButtons,
  UsersSettingsButtonsWrapper,
} from './style'

interface IProps {
  persons: Person[]
}

export const UserPicker = ({ persons }: IProps) => {
  const dispatch = useAppDispatch()

  const calendarSettings = useAppSelector(calendarSettingsSelector)
  const colorContrast = calendarSettings.colorContrast
  const inActivePersonIds = calendarSettings.inActivePersonIds

  const addInActiveUser = (personId: number): void => {
    const updatedIds: number[] = [...inActivePersonIds, personId]
    dispatch(setInActivePersonIds({ inActivePersonIds: updatedIds }))
    return setUserSettings({ inActivePersonIds: updatedIds })
  }

  const removeInActiveUser = (personId: number): void => {
    const updatedIds: number[] = inActivePersonIds.filter(
      inActivePersonId => inActivePersonId !== personId,
    )
    dispatch(setInActivePersonIds({ inActivePersonIds: updatedIds }))
    return setUserSettings({ inActivePersonIds: updatedIds })
  }

  if (!persons) {
    return null
  }

  return (
    <UsersSettingsButtonsWrapper>
      {persons.map(person => {
        const isInActivePerson: boolean = inActivePersonIds.includes(person.id)
        return (
          <UsersSettingsButtons
            value={person.id}
            colorContrast={colorContrast}
            active={!isInActivePerson}
            disabled={
              !isInActivePerson &&
              persons.length - 1 === inActivePersonIds.length
            }
            key={person.id}
            onClick={() =>
              isInActivePerson
                ? removeInActiveUser(person.id)
                : addInActiveUser(person.id)
            }>
            <UserSettingsAvatar src={`${person.avatar}&w=25&h=25&fit=crop`} />
            <UserSettingsText>{person.firstName}</UserSettingsText>
          </UsersSettingsButtons>
        )
      })}
    </UsersSettingsButtonsWrapper>
  )
}
